import { D } from '@wave/shared';

/**
 * Валюты чата, чьё значение «залипло»: они не обновлялись заметно дольше
 * самой свежей валюты того же чата при ненулевой сумме.
 *
 * Страховка на случай формата сообщения, который не распознаётся как полный
 * снимок (см. update-chat-balance): прод-случай EUR −5942 висел 42 часа,
 * искажая позицию на ~6.9k USDT, и увидеть это можно было только запросом в БД.
 *
 * Возвращает Map: валюта → на сколько ЧАСОВ (целых, вниз) она отстала от
 * самой свежей валюты чата. Валюты без updatedAt (source='api'/'tron') и
 * нулевые суммы не попадают в результат.
 *
 * `thresholdHours` = 6 — та же величина, что `STALE_LAG_HOURS` в
 * `apps/api/src/modules/telegram-listener/handlers/update-chat-balance.ts`
 * (страховка «лаг»: валюту обнуляет только отставание не меньше порога).
 * Бейдж и обнуление обязаны срабатывать на одном и том же признаке —
 * меняешь здесь, меняй и там.
 */
export function staleCcys(
  balances: Array<{ ccy: string; amount: string; updatedAt: string | null }>,
  thresholdHours = 6,
): Map<string, number> {
  const out = new Map<string, number>();
  const stamps = balances
    .map((b) => (b.updatedAt ? new Date(b.updatedAt).getTime() : null))
    .filter((t): t is number => t !== null && !Number.isNaN(t));
  if (stamps.length === 0) return out;
  const freshest = Math.max(...stamps);
  for (const b of balances) {
    if (!b.updatedAt) continue;
    if (D(b.amount).isZero()) continue;
    const lagH = Math.floor((freshest - new Date(b.updatedAt).getTime()) / 3_600_000);
    if (lagH >= thresholdHours) out.set(b.ccy, lagH);
  }
  return out;
}
